<!-- 客户服务按钮 -->
<template>
    <div class="client-service-container">
        <div class="suspension-img" :style="{left: targetLocation.left+'px',top: targetLocation.top+'px'}" ref="target"
            @touchstart="touchStart" @touchmove.prevent="touchMove" @click="showPopup = true">
            <img class="img" @load="targetOnload" src="@/assets/img/service.png" alt="">
            <p class="hint">联系客服</p>
        </div>
        <van-popup v-model="showPopup">
            <div class="contact-way">
                <div class="title">欢迎咨询</div>
                <div class="list">
                    <div class="item">
                        <div class="left">
                            <div class="img-icon">
                                <img class="phone-icon" src="@/assets/img/phone.png" alt="">
                            </div>
                            <div class="text">400 885 6070</div>
                        </div>
                        <button class="right-btn">
                            <a href="tel:400-885-6070">拨号</a>
                        </button>
                    </div>
                    <!-- <div class="item">
                        <div class="left">
                            <div class="img-icon">
                                <img class="phone-icon" src="@/assets/img/consult.png" alt="">
                            </div>
                            <div class="text">在线咨询</div>
                        </div>
                        <button class="right-btn" @click="consult">咨询</button>
                    </div> -->
                    <div class="item">
                        <div class="left">
                            <div class="img-icon">
                                <img class="fill-in" src="@/assets/img/fill-in.png" alt="">
                            </div>
                            <div class="text">自助申请</div>
                        </div>
                        <button class="right-btn" @click="fillIn">填写</button>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showType">
            <div class="industry-type">
                <div class="top-img">
                    <img class="logo" src="@/assets/img/advisory-icon.png" alt="">
                    <p class="hint-text">选择咨询类别</p>
                </div>
                <div class="btn">
                    <van-button type="info" color="#6BC4DA" size="large" @click="skipService(1)">价格/货号咨询</van-button>
                </div>
                <div class="btn">
                    <van-button type="info" color="#6BC4DA" size="large" @click="skipService(2)">技术支持</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    data () {
        return {
            // 目标要移动到的位置
            targetLocation: {
                left: 350,
                top: 400
            },
            initLocation: {}, // 要移动之前的初始位置
            // 触摸开始的位置
            touchStartLocation: {},
            maxLength: {}, // 最大移动距离
            showPopup: false,
            showType: false
        }
    },
    // props: {
    //   testing: {
    //     type: String,
    //     default: ''
    //   }
    // },
    created () {},
    mounted () {},
    methods: {
        targetOnload () {
            // console.log('加载完毕了吗')
            // 屏幕宽高
            var screenWH = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
            // 要移动的目标的宽高
            var targetWH = {
                width: this.$refs.target.clientWidth,
                height: this.$refs.target.clientHeight
            }

            // 计算最大移动距离
            var maxLength = {
                x: screenWH.width - targetWH.width,
                y: screenWH.height - targetWH.height
            }
            this.maxLength = maxLength

            // 设置初始距离，靠右
            this.targetLocation.left = maxLength.x
        // Toast(JSON.stringify(maxLength));
        },
        // 获取触点位置
        touchPos (e) {
            var touches = e.changedTouches[0]
            var oPosition = {
                clientX: touches.clientX,
                clientY: touches.clientY
            }
            return oPosition
        },
        // 触摸开始
        touchStart (e) {
            // 要移动的目标的初始位置
            var initLocation = {
                x: this.$refs.target.offsetLeft,
                y: this.$refs.target.offsetTop
            }
            this.initLocation = initLocation

            var touchStartLocation = this.touchPos(e)
            this.touchStartLocation = touchStartLocation
        // console.log('触摸开始的位置', touchStartLocation)
        },
        // 触摸移动
        touchMove (e) {
            var changedTouches = this.touchPos(e)
            // 移动的距离 = 移动之后的位置 - 触摸开始时的位置
            var moveX = -(
                this.touchStartLocation.clientX - changedTouches.clientX
            )
            var moveY = -(
                this.touchStartLocation.clientY - changedTouches.clientY
            )
            // console.log(`moveX：${moveX}，moveY：${moveY}`)

            // 目标要移动到的位置 = 目标的初始位置 + 移动的距离
            var targetLocation = {
                left: parseInt(this.initLocation.x + moveX),
                top: parseInt(this.initLocation.y + moveY)
            }
            // console.log(targetLocation)

            // 加一些移动的限制
            if (targetLocation.left < 0) {
                targetLocation.left = 0
            } else if (targetLocation.left > this.maxLength.x) {
                targetLocation.left = this.maxLength.x
            }

            if (targetLocation.top < 0) {
                targetLocation.top = 0
            } else if (targetLocation.top > this.maxLength.y) {
                targetLocation.top = this.maxLength.y
            }

            this.targetLocation = {
                left: targetLocation.left,
                top: targetLocation.top
            }
        },
        // 跳转客服
        skipService (val) {
            var urlLink = ''
            switch (val) {
            case 1:
                urlLink =
                    'https://chat.sobot.com/chat/h5/v2/index.html?sysnum=4d6da9812b694fc293b8556b6a82df44&source=1&agentid=193f9fafbcfb4f7990d74a4c431af54f&type=4'
                break
            case 2:
                urlLink =
                    'https://chat.sobot.com/chat/h5/v2/index.html?sysnum=4d6da9812b694fc293b8556b6a82df44&source=1&agentid=a99c997b631c453b8fc01eca48348c96&type=4'
                break
            }
            // console.log(urlLink)
            window.location.href = urlLink
        },
        fillIn () {
            // if (this.testing) {
            //   this.$router.push({
            //     name: 'applyQuotation'
            //   })
            // } else {
            //   window.location.href =
            //     'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe0041fb80f56b33e&redirect_uri=https%3a%2f%2ftools.eppendorf.cn%2fcentrifugation%2fApply.aspx&response_type=code&scope=snsapi_base&state=123#wechat_redirect'
            // }
            this.$router.push({
                name: 'applyQuotation'
            })
        },
        // 单击咨询
        consult () {
            window.location.href = 'http://55793588.im.m.weimob.com'
        }
    }
}
</script>

<style lang="scss" scoped>
.client-service-container {
    .suspension-img {
        position: fixed;
        z-index: 999;
        width: rem(50);
        height: rem(50);
        // background: $base-color;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(131deg, #82d2e6 0%, #5eb6cc 100%);
        box-shadow: 0 0 10px #888888;

        &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .img {
            width: rem(26);
            height: rem(26);
        }

        .hint {
            font-size: 9px;
            color: #fff;
        }
    }

    .van-popup {
        border-radius: 8px;
    }

    .contact-way {
        width: rem(303);
        /*height: rem(185);*/
        background: #fff;
        padding: rem(20) rem(27);

        .title {
            font-size: rem(18);
            color: $base-color;
            height: rem(45);
            line-height: rem(45);
            text-align: center;
        }

        .list {
            .item {
                height: rem(45);

                &:not(:last-child) {
                    border-bottom: 1px solid #ebebeb;
                }

                display: flex;
                align-items: center;
                justify-content: space-between;

                .left {
                    display: flex;
                    align-items: center;

                    .img-icon {
                        width: rem(25);
                        margin-right: rem(10);
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .phone-icon {
                            width: rem(22);
                            height: rem(19);
                        }

                        .fill-in {
                            width: rem(25);
                        }
                    }

                    .text {
                        color: $base-color;
                        font-size: rem(16);
                    }
                }

                .right-btn {
                    background: $base-color;
                    font-size: 15px;
                    color: #fff;
                    outline: none;
                    border: none;
                    height: rem(25);
                    padding: 0 rem(14);
                    border-radius: 4px;
                    display: inline-block;

                    a {
                        color: #fff;
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .industry-type {
        width: rem(280);
        height: rem(290);
        padding-top: rem(15);
        padding-bottom: rem(25);

        .top-img {
            text-align: center;

            .logo {
                width: rem(96);
                height: rem(96);
            }

            .hint-text {
                color: #4d4d4d;
                font-size: rem(13);
                font-weight: bold;
                margin-top: rem(16);
            }
        }

        .btn {
            width: 60%;
            margin: 0 auto;
            margin-top: rem(16);

            .van-button--large {
                height: rem(40);
                line-height: rem(40);
                border-radius: 5px;
            }
        }
    }
}
</style>
